import useActionReducer from '@admin/hooks/use_action_reducer'
import * as actions from './actions'
import Navigation from './navigation'
import PropTypes from 'prop-types'
import reducer from './reducer'
import React from 'react'

const NavigationContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'navigation',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <Navigation { ...mergedProps } />

}

NavigationContainer.propTypes = {}

export default NavigationContainer